import axios from 'axios';

const { protocol, hostname } = window.location;

let API_BASE_URL;

// Handle localhost → DEV
if (
  hostname === 'localhost' ||
  hostname === '127.0.0.1'
) {
  API_BASE_URL = 'https://dev-allaccess.amaphil.com.ph/api/v1';
} else {
  // dev-allaccess / allaccess / staging (auto)
  API_BASE_URL = `${protocol}//${hostname}/api/v1`;
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const getAuthToken = () =>
  localStorage.getItem('authentication/token') ||
  localStorage.getItem('auth_token') ||
  localStorage.getItem('token') ||
  '';

const getBearerAuthHeaders = () => {
  const token = getAuthToken();

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const withBearerAuth = (config = {}) => ({
  ...config,
  headers: {
    ...(config.headers || {}),
    ...getBearerAuthHeaders(),
  },
});

// Attach auth token
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const activityLogsAPI = {
  getLogs: (filters) =>
    api.get('/activity-logs', withBearerAuth({ params: filters })),

  getStatistics: (filters) =>
    api.get('/activity-logs/statistics', withBearerAuth({ params: filters })),

  getFilterOptions: () =>
    api.get('/activity-logs/filter-options', withBearerAuth()),

  exportLogs: (filters, format) =>
    api.get('/activity-logs/export', withBearerAuth({
      params: { ...filters, format },
      responseType: 'blob',
    })),
};

export default api;
